module.exports = __webpack_public_path__ + "static/img/MTI-Economy-B-普及B型.d2586f14.jpg";